import { render, staticRenderFns } from "./EntryList.vue?vue&type=template&id=36832148&scoped=true"
import script from "./EntryList.vue?vue&type=script&lang=js"
export * from "./EntryList.vue?vue&type=script&lang=js"
import style0 from "./EntryList.vue?vue&type=style&index=0&id=36832148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36832148",
  null
  
)

export default component.exports